import { getRequest, putRequest } from '../../axios/requests';
import API from '../../constant.api';

export interface OrganizationSettings {
  // a loan jewel's net weight is (gross - stone) less this percentage
  netWeightReductionPercentage: number;
}

// Any signed-in role can read the settings; only the superadmin can change them
export const fetchOrganizationSettings =
  async (): Promise<OrganizationSettings> => {
    const { data } = await getRequest(API.ORGANIZATION_SETTINGS, {});
    return data;
  };

export const updateOrganizationSettings = async (
  payload: OrganizationSettings
): Promise<{ message: string; settings: OrganizationSettings }> => {
  const { data } = await putRequest(API.ORGANIZATION_SETTINGS, payload);
  return data;
};
